/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgentEditorSuggestionsQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type AgentEditorSuggestionsQuery = { agentEditorSuggestions: { __typename: 'AgentEditorSuggestionsResult', pending: boolean, suggestions: Array<{ __typename: 'AgentEditorSuggestion', id: string, itemId: string, severity: Types.AgentSuggestionSeverity, source: Types.AgentSuggestionSource, title: string, detail: string, fixLabel?: string | null, hasFix: boolean, removesItemIds: Array<string>, assistantPrompt?: string | null }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type ApplyAgentEditorSuggestionMutationVariables = Types.Exact<{
  input: Types.AgentSuggestionActionInput;
}>;


export type ApplyAgentEditorSuggestionMutation = { applyAgentEditorSuggestion: { __typename: 'AgentApplySuggestionResult', applied: boolean } };

export type DismissAgentEditorSuggestionMutationVariables = Types.Exact<{
  input: Types.AgentSuggestionActionInput;
}>;


export type DismissAgentEditorSuggestionMutation = { dismissAgentEditorSuggestion: { __typename: 'AgentDismissSuggestionResult', dismissed: boolean } };


export const AgentEditorSuggestionsDocument = gql`
    query AgentEditorSuggestions($templateId: ID!) {
  agentEditorSuggestions(templateId: $templateId) {
    __typename
    ... on AgentEditorSuggestionsResult {
      pending
      suggestions {
        id
        itemId
        severity
        source
        title
        detail
        fixLabel
        hasFix
        removesItemIds
        assistantPrompt
      }
    }
  }
}
    `;

/**
 * __useAgentEditorSuggestionsQuery__
 *
 * To run a query within a React component, call `useAgentEditorSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentEditorSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentEditorSuggestionsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useAgentEditorSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<AgentEditorSuggestionsQuery, AgentEditorSuggestionsQueryVariables> & ({ variables: AgentEditorSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentEditorSuggestionsQuery, AgentEditorSuggestionsQueryVariables>(AgentEditorSuggestionsDocument, options);
      }
export function useAgentEditorSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentEditorSuggestionsQuery, AgentEditorSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentEditorSuggestionsQuery, AgentEditorSuggestionsQueryVariables>(AgentEditorSuggestionsDocument, options);
        }
export function useAgentEditorSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentEditorSuggestionsQuery, AgentEditorSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentEditorSuggestionsQuery, AgentEditorSuggestionsQueryVariables>(AgentEditorSuggestionsDocument, options);
        }
export type AgentEditorSuggestionsQueryHookResult = ReturnType<typeof useAgentEditorSuggestionsQuery>;
export type AgentEditorSuggestionsLazyQueryHookResult = ReturnType<typeof useAgentEditorSuggestionsLazyQuery>;
export type AgentEditorSuggestionsSuspenseQueryHookResult = ReturnType<typeof useAgentEditorSuggestionsSuspenseQuery>;
export type AgentEditorSuggestionsQueryResult = Apollo.QueryResult<AgentEditorSuggestionsQuery, AgentEditorSuggestionsQueryVariables>;
export const ApplyAgentEditorSuggestionDocument = gql`
    mutation ApplyAgentEditorSuggestion($input: AgentSuggestionActionInput!) {
  applyAgentEditorSuggestion(input: $input) {
    applied
  }
}
    `;
export type ApplyAgentEditorSuggestionMutationFn = Apollo.MutationFunction<ApplyAgentEditorSuggestionMutation, ApplyAgentEditorSuggestionMutationVariables>;

/**
 * __useApplyAgentEditorSuggestionMutation__
 *
 * To run a mutation, you first call `useApplyAgentEditorSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyAgentEditorSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyAgentEditorSuggestionMutation, { data, loading, error }] = useApplyAgentEditorSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyAgentEditorSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<ApplyAgentEditorSuggestionMutation, ApplyAgentEditorSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyAgentEditorSuggestionMutation, ApplyAgentEditorSuggestionMutationVariables>(ApplyAgentEditorSuggestionDocument, options);
      }
export type ApplyAgentEditorSuggestionMutationHookResult = ReturnType<typeof useApplyAgentEditorSuggestionMutation>;
export type ApplyAgentEditorSuggestionMutationResult = Apollo.MutationResult<ApplyAgentEditorSuggestionMutation>;
export type ApplyAgentEditorSuggestionMutationOptions = Apollo.BaseMutationOptions<ApplyAgentEditorSuggestionMutation, ApplyAgentEditorSuggestionMutationVariables>;
export const DismissAgentEditorSuggestionDocument = gql`
    mutation DismissAgentEditorSuggestion($input: AgentSuggestionActionInput!) {
  dismissAgentEditorSuggestion(input: $input) {
    dismissed
  }
}
    `;
export type DismissAgentEditorSuggestionMutationFn = Apollo.MutationFunction<DismissAgentEditorSuggestionMutation, DismissAgentEditorSuggestionMutationVariables>;

/**
 * __useDismissAgentEditorSuggestionMutation__
 *
 * To run a mutation, you first call `useDismissAgentEditorSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAgentEditorSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAgentEditorSuggestionMutation, { data, loading, error }] = useDismissAgentEditorSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissAgentEditorSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<DismissAgentEditorSuggestionMutation, DismissAgentEditorSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAgentEditorSuggestionMutation, DismissAgentEditorSuggestionMutationVariables>(DismissAgentEditorSuggestionDocument, options);
      }
export type DismissAgentEditorSuggestionMutationHookResult = ReturnType<typeof useDismissAgentEditorSuggestionMutation>;
export type DismissAgentEditorSuggestionMutationResult = Apollo.MutationResult<DismissAgentEditorSuggestionMutation>;
export type DismissAgentEditorSuggestionMutationOptions = Apollo.BaseMutationOptions<DismissAgentEditorSuggestionMutation, DismissAgentEditorSuggestionMutationVariables>;